import { enumLabel } from "../../components/ui/enumLabel";
import "./SupportTicketModal.css";
import Select from "../../components/ui/Select";
import Button from "../../components/ui/Button";
import React, { useEffect, useState } from "react";
import { SupportStatus, SupportTicket } from "../../types/supportTicket";
import { closeSupportTicket, getSupportTicket, updateSupportTicketStatus } from "../../services/supportTicketService";
import { getApiErrorMessage } from "../../utils/apiError";
import { useAccess } from "../../hooks/useAccess";
import Modal from "../Modal/Modal";

export default function SupportTicketModal({ isOpen, onClose, ticket, onUpdated }: { isOpen: boolean; onClose: () => void; ticket: SupportTicket; onUpdated?: () => void }) {
  const { can } = useAccess();
  const [detail, setDetail] = useState<SupportTicket | null>(null);
  const [status, setStatus] = useState<SupportStatus>(ticket.status);
  const [response, setResponse] = useState("");
  const [busy, setBusy] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [attempt, setAttempt] = useState(0);
  useEffect(() => {
    if (!isOpen) return;
    const controller = new AbortController(); setLoading(true); setError("");
    getSupportTicket(ticket.ticketId, controller.signal).then(value => { if (!controller.signal.aborted) { setDetail(value); setStatus(value.status); } })
      .catch(err => { if (!controller.signal.aborted) setError(getApiErrorMessage(err)); })
      .finally(() => { if (!controller.signal.aborted) setLoading(false); });
    return () => controller.abort();
  }, [isOpen, ticket.ticketId, attempt]);
  if (!isOpen) return null;
  const save = async (operation: () => Promise<unknown>) => {
    setBusy(true); setError("");
    try { await operation(); onUpdated?.(); onClose(); } catch (err) { setError(getApiErrorMessage(err)); } finally { setBusy(false); }
  };
  return <Modal size="medium" title={`Ticket ${ticket.ticketId}`} onClose={() => { if (!busy) onClose(); }}>
    {error && <p className="integration-error" role="alert">{error} <Button onClick={() => setAttempt(value => value + 1)}>Reload ticket</Button></p>}
    {loading ? <p role="status">Loading ticket...</p> : detail && <>
      <h3>{detail.title}</h3><p>{detail.name} · {detail.email}</p><div className="ticket-detail-badges"><span>{enumLabel(detail.status)}</span><span>{enumLabel(detail.priority)} priority</span></div><p>Created {new Date(detail.createdAt).toLocaleString()}</p>
      {detail.response && <section><h3>Saved response</h3><p style={{ whiteSpace: "pre-wrap" }}>{detail.response}</p></section>}
      {can("support_tickets.manage") && <div className="integration-form">
        <label>Status<Select value={status} disabled={busy} onChange={event => setStatus(event.target.value as SupportStatus)}>{["pending", "answered", "closed"].map(value => <option key={value}>{value}</option>)}</Select></label>
        <Button disabled={busy || status === detail.status} onClick={() => save(() => updateSupportTicketStatus(detail.ticketId, status))}>Save status</Button>
        {detail.status !== "closed" && <form className="integration-form" onSubmit={event => { event.preventDefault(); save(() => closeSupportTicket(detail.ticketId, response.trim())); }}>
          <label>Closing response<textarea value={response} onChange={event => setResponse(event.target.value)} maxLength={1000} required disabled={busy} /></label>
          <Button variant="primary" type="submit" disabled={busy || !response.trim()}>Save response and close ticket</Button>
        </form>}
      </div>}
    </>}
  </Modal>;
}
